const LogoutView = () => {

  return <div>Logging Out...</div>
}

export default LogoutView